export const LIVE_NOTIFICATION_EVENT = 'acompanha:live-notification';

export const LIVE_NOTIFICATION_KINDS = {
    JOB_INTEGRATION_CHANGED: 'job_integration_changed',
    APP_INBOX_UPDATED: 'app_inbox_updated',
    PRINTER_SNAPSHOT_UPDATED: 'printer_snapshot_updated',
};

export const LIVE_INBOX_KINDS = {
    SUBSCRIPTION_CHARGE_READY: 'subscription_charge_ready',
};

export const SUBSCRIPTION_PAGE_PATH = '/admin/my-account/subscription';

export function emitLiveNotification(detail) {
    window.dispatchEvent(new CustomEvent(LIVE_NOTIFICATION_EVENT, { detail }));
}

export function subscribeLiveNotifications(handler) {
    const listener = (event) => handler(event.detail);
    window.addEventListener(LIVE_NOTIFICATION_EVENT, listener);
    return () => window.removeEventListener(LIVE_NOTIFICATION_EVENT, listener);
}

export function isJobIntegrationLiveNotification(detail) {
    return detail?.kind === LIVE_NOTIFICATION_KINDS.JOB_INTEGRATION_CHANGED;
}

export function isPrinterSnapshotLiveNotification(detail) {
    return detail?.kind === LIVE_NOTIFICATION_KINDS.PRINTER_SNAPSHOT_UPDATED;
}

export function isAppInboxLiveNotification(detail) {
    return detail?.kind === LIVE_NOTIFICATION_KINDS.APP_INBOX_UPDATED;
}
